<template>
  <v-row align="center" justify="center" class="backgroundColor">
    <v-dialog v-model="loader" persistent max-width="50%">
      <v-card
        color="background"
      >
        <v-card-text class="body-2 font-weight-medium text-center">
          Cargando...
          <v-progress-linear
            rounded
            indeterminate
            color="primary"
            class="mb-0 mt-1"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["loader"]),
  },
};
</script>

<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
}
</style>